export default function createRazorBuilder(options) {
  const self = {
    components: [],
    add: (component) => {
      // console.log("builder.add", component);
      self.components.push(component);
      // component.selector
      // component.create
      // component.attach
      return self;
    },
    init: (win) => {
      self.components.forEach((compo) => {
        Array.from(win.document.querySelectorAll(compo.selector)).forEach((node) => {
          compo.attach(node);
          // console.log("attach component", compo.selector, node);
        });
      });
    },
  };
  return self;
}
